import React from "react";
import {
    List,
    Datagrid,
    TextField, Edit, EditButton, TextInput, Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const InnerSoundBuyHistoryFilter = (props) => (
    <Filter {...props}>
        <TextInput source="charge_code" label="Code" alwaysOn/>
    </Filter>
);

const form = <BaseForm fields={
    {
        name: '',
        user_code: '',
        user_name: '',
        user_email: '',
        package_name: '',
        duration_of_month: '',
        price: '',
        f0_code: '',
        f0_name: '',
        f0_email: '',
        created_at: '',
        f0_commission: '',
        company_profit: '',
    }
} selections={
    {status: 'book-order-status'}
}/>

export const InnerSoundBuyHistoryList = props => (
    <List {...props} filters={<InnerSoundBuyHistoryFilter/>} title="Inner sound license buy history"
          filter={{is_published: true}}>
        <Datagrid>
            <TextField source="stt"/>
            <TextField source="created_at"/>
            <TextField source="code"/>
            <TextField source="user_code"/>
            <TextField source="user_name"/>
            <TextField source="user_email"/>
            <TextField source="package_name"/>
            <TextField source="duration_of_month"/>
            <TextField source="price"/>
            <TextField source="payment_method"/>
            <TextField source="f0_code"/>
            <TextField source="f0_name"/>
            <TextField source="f0_email"/>
            <TextField source="f0_commission"/>
            <TextField source="company_profit"/>
            <TextField source="status"/>
            <EditButton basePath="/inner-sound-buy-history"/>
        </Datagrid>
    </List>
);

export const InnerSoundBuyHistoryPaidList = props => (
    <List {...props} filters={<InnerSoundBuyHistoryFilter/>} title="Inner sound license buy history paid"
          filter={{is_published: true}}>
        <Datagrid>
            <TextField source="code"/>
            <TextField source="stt"/>
            <TextField source="created_at"/>
            <TextField source="user_code"/>
            <TextField source="user_name"/>
            <TextField source="user_email"/>
            <TextField source="package_name"/>
            <TextField source="duration_of_month"/>
            <TextField source="price"/>
            <TextField source="payment_method"/>
            <TextField source="f0_code"/>
            <TextField source="f0_name"/>
            <TextField source="f0_email"/>
            <TextField source="f0_commission"/>
            <TextField source="company_profit"/>
        </Datagrid>
    </List>
);

export const InnerSoundBuyHistoryEdit = props => (
    <Edit {...props}>
        {form}
    </Edit>
);
